<template>
  <el-dialog title="非纯EXCEL缩水技巧授之以渔本"
             :visible.sync="feichunShow"
             width="80%">
	<div class="title">授之以渔</div>
	<div class="msg">
		很多老彩民在长期的实践中，积累了一些自己独创的缩水思路和方法，由于缩水是需要花时同去采集、收集、分析、整理、综合等等,时间的限制，往往不可能每朝都去做一些相对成熟的缩水数据。而另外一些彩民也需要”引进“新的思路，做一些镇定可靠的缩水单，为了让有时间和没有时间的皆深彩民进行优势互补，我们开辟了这个《授之以逢》平台，供彩民们交流。
	</div>

	<el-table
		:header-cell-style="{background:'#93d2f3',color:'#000000'}"
	>
		<el-table-column prop="prop" label="序号"></el-table-column>
		<el-table-column prop="prop" label="申请人"></el-table-column>
		<el-table-column prop="prop" label="申请时间"></el-table-column>
		<el-table-column prop="prop" label="授之以渔文档及excel"></el-table-column>
		<el-table-column prop="prop" label="授之以渔专利转让协议签名确认"></el-table-column>
		<el-table-column prop="prop" label="平台审核人员是否跟进确认验证授之以渔"></el-table-column>
		<el-table-column prop="prop" label="授之以渔挂牌交易（缩币）"></el-table-column>
		<el-table-column prop="prop" label="授之以渔交易情况"></el-table-column>
	</el-table>	
  </el-dialog>
</template>

<script>
export default {
	data(){
		return{
			feichunShow:false,
		}
	}
}
</script>

<style lang="scss" scoped>
	.title{
		display: block;
		width: 200px;
		padding: 10px 0;
		margin:auto;
		text-align: center;
		font-size: 30px;
		font-weight: bold;
		color: #cf1322;
		background-color: #93d2f3;
	}
	.msg{
		border: 1px solid rgba(0,0,0,.2);
		border-bottom: 0;
		padding: 20px;
		text-indent: 3em;
	}
</style>